import React from 'react';
import '../App.css';
import {render} from 'react-dom';
import gogs from './gogs2.jpg';
import {ExternalLink} from 'react-external-link';


class Engine extends React.Component{
    constructor(props){
        super(props);
    }
    render(){
        return(
            <>
                <div className="enginePage">
                    <h1 className="engineTitle">engineering.</h1>
                    <div >
                        <img className='engineImage' src={gogs} alt="gogs" style={{width:'60%'}}/>
                    </div>
                    <div>
                        <h2 className="textFlip" style={{ marginLeft:'20%'}}>ELECTROCHROMIC SKI GOGGLES</h2>
                    </div>
                    
                    
                </div>
                <div className="engineLower">
                    <div className="engineBio">
                        <p>The one constant in my life is my appreciation for simple beauty,<br/> when the complex suddenly becomes elementary,<br/> it is in these astounding moments that the world seems clear.</p>
                    </div>
                    <div className="checkIt3">
                        <p className="linkPara3"><ExternalLink className="linkage3" href="http://joshdiesenhaus.com/engineering">check it.</ExternalLink></p>
                    </div>
                </div>
            </>
        );
    }
}

export default Engine;